import classes from './Content.module.css';

type ContentProps = {
  children: React.ReactNode;
};

const Content = ({ children }: ContentProps) => {
  return <main className={classes.content}>{children}</main>;
};

export default Content;
